import { Predicate } from './predicate.type'

export function isPredicate<T>(
  value: Predicate<T> | boolean | number | number[]
): value is Predicate<T> {
  return typeof value === 'function'
}
